import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import session from "../Utils/session";

const ERRORS = {
  access_denied: "Your ioprodz account doesn't have access to Muzio.",
  expired: "The sign-in took too long. Please try again.",
};

// Landing page of "Sign in with ioprodz": the server redirects here with
// #access_token=… or #error=… in the fragment.
export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.slice(1));
    window.history.replaceState(null, "", window.location.pathname);
    const token = params.get("access_token");
    if (token) {
      session.setSession(token);
      navigate("/app", { replace: true });
    } else {
      const code = params.get("error");
      setError(ERRORS[code] || "Sign in with ioprodz failed. Please try again.");
    }
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-full bg-primary p-4">
      <div className="w-full max-w-md bg-secondary border border-neutral-800 rounded-md shadow-2xl p-8 text-center">
        {error ? (
          <>
            <p className="text-white mb-6">{error}</p>
            <Link to="/auth" className="text-accent font-medium">
              Back to sign in
            </Link>
          </>
        ) : (
          <p className="text-gray-400">Signing in…</p>
        )}
      </div>
    </div>
  );
}
